// src/App.js
import React, { useState } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import PaisList from './components/PaisList';
import CiudadList from './components/CiudadList';
import UniversidadList from './components/UniversidadList';
import DirectivaList from './components/DirectivaList';
import CargoList from './components/CargoList';
import SocioList from './components/SocioList';
import SocioReport from './components/SocioReport';
import './App.css';
import * as bootstrap from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import GradoList from './components/GradoList';
import LoginForm from './components/LoginForm';
import { UserProvider } from './store/user-context';
import { checkAdminLoader, checkAuthLoader, tokenLoader } from './util/auth';
import { RootLayout } from './pages/Root';
import ErrorPage from './pages/Error';
import InicioPage from './pages/Inicio';
import GenCuotas from './components/GenCuotas';
import UsuarioList from './components/UsuarioList';
import SocioListGen from './components/SocioListGen';
import ActualizarMontosCuotas from './components/ActualizarMontosCuotas';
import RolList from './components/RolList';
import ActualizarDatosGenerales from './components/ActualizarDatosGenerales';
import NoticiaList from './components/NoticiaList';
import TipoIngresoList from './components/TipoIngresoList';
import IngresosList from './components/IngresosList';

// 👇 Importa el visor público del certificado (modal)
import VerCertificadoQRModal from './components/VerCertificadoQRModal';

function App() {
  const [currentId, setCurrentId] = useState(null);

  const router = createBrowserRouter([
    // ===== RUTA PÚBLICA (fuera del RootLayout) =====
    { path: '/ver-certificado/:codigo', element: <VerCertificadoQRModal /> },

    // ===== RUTAS DEL SISTEMA (con layout, loaders, auth, etc.) =====
    {
      path: '/',
      element: <RootLayout />,
      errorElement: <ErrorPage />,
      id: 'root',
      loader: tokenLoader, // <- este loader NO se ejecutará para /ver-certificado/...
      children: [
        { path: '/', element: <InicioPage /> },
        { path: '/login', element: <LoginForm /> },
        { path: '/paises', element: <PaisList setCurrentId={setCurrentId} />, loader: checkAuthLoader },
        { path: '/ciudades', element: <CiudadList />, loader: checkAuthLoader },
        { path: '/universidades', element: <UniversidadList />, loader: checkAuthLoader },
        { path: '/socios/:drol', element: <SocioList />, loader: checkAdminLoader },
        { path: '/grados', element: <GradoList />, loader: checkAuthLoader },
        { path: '/directivas/:titulo/:funcionalidad', element: <DirectivaList currentId={currentId} />, loader: checkAuthLoader },
        { path: '/cargos', element: <CargoList currentId={currentId} />, loader: checkAuthLoader },
        { path: '/roles', element: <RolList currentId={currentId} />, loader: checkAuthLoader },
        { path: '/tipo-ingresos', element: <TipoIngresoList currentId={currentId} />, loader: checkAuthLoader },
        { path: '/generar-cuotas', element: <GenCuotas currentId={currentId} />, loader: checkAuthLoader },
        { path: '/usuarios/:titulo/:funcionalidad', element: <UsuarioList currentId={currentId} />, loader: checkAuthLoader },
        { path: '/socio-list-gen/:titulo/:funcionalidad', element: <SocioListGen currentId={currentId} />, loader: checkAuthLoader },
        { path: '/actualizar-montos-cuotas', element: <ActualizarMontosCuotas currentId={currentId} />, loader: checkAuthLoader },
        { path: '/actualizar-datos-generales', element: <ActualizarDatosGenerales currentId={currentId} />, loader: checkAuthLoader },
        { path: '/noticias', element: <NoticiaList currentId={currentId} />, loader: checkAuthLoader },
        { path: '/reportes', element: <SocioReport currentId={currentId} />, loader: checkAuthLoader },
        { path: '/ingresos', element: <IngresosList />, loader: checkAuthLoader },
      ],
    },

    // (Opcional) 404 catch-all para cualquier otra ruta
    // { path: '*', element: <ErrorPage /> },
  ]);

  return (
    <UserProvider>
      <RouterProvider router={router} />
    </UserProvider>
  );
}

export default App;
